import * as React from "react";
import Box from "@mui/material/Box";
import "@fontsource/lato";
import Avatar from "@mui/material/Avatar";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { Theme, NaviStyle } from "../styles/styles";
import { ThemeProvider } from "@mui/material/styles";
import { Button, Modal, Typography } from "@mui/material";
import NoPhotographyOutlinedIcon from '@mui/icons-material/NoPhotographyOutlined';
import { useState, useEffect } from "react";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";

export const CompanyInfoCard = ({
    goodPionts,
    logoImg,
    companyName = "Brak informacji",
    companyDescription = "Brak informacji",
    profileId,
    companyInfoOnClickButtonAction,
    
    clickButtonHandler,

}) => {

    const [profileData, setProfileData] = useState([]);

    
    const navigate = useNavigate()

    const { seolink } = useParams();

   

   

    return (
        <ThemeProvider theme={Theme}>
            <Box
                id="mainBox"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: "#FFFFFF",
                    //p: "24px",
                    justifyContent: "center",
                    [Theme.breakpoints.down("tablet")]: {
                        width: "100vw",
                        minHeight: "547px",

                    },
                    [Theme.breakpoints.up("tablet")]: {
                        width: "30vw",
                        minHeight: "723px",
                        borderRadius: "16px"
                    },
                    [Theme.breakpoints.up("laptop")]: {
                        width: "22vw",
                    },
                    [Theme.breakpoints.up("desktop")]: {
                        width: "18vw",
                        //height: "70vh",
                        minHeight: "unset",
                        maxHeight: "70vh",
                        //overflow: "auto",
                    },

                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        p:"16px",
                        [Theme.breakpoints.up("tablet")]: {
                            alignSelf: "flex-end"
                        },
                    }}>
                    <Avatar sx={{ bgcolor: "#f29a26", width: 27, height: 27, mr: "8px" }}>
                        <FavoriteIcon
                            sx={{
                                fontSize: 14,
                                color: "#fff",
                            }}
                        />
                    </Avatar>
                    <Typography variant="subtitle"

                    >{goodPionts}
                    </Typography>

                </Box>
                <Box
                    id="Line_Separator"
                    sx={{ borderBottom: 1, borderColor: "#e3e3e3", width: "100%", mb: "16px", mt: "10px" }}
                ></Box>
                <Avatar variant="square"
                    src={logoImg}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        //p:"24px",
                        bgcolor: "#fff",
                        borderRadius: "12px",
                        width: "85.6%",
                        maxHeight: "20vh",
                        height: "auto",
                        objectFit: "contain",

                    }}
                >
                    {!logoImg &&
                        <NoPhotographyOutlinedIcon
                            sx={{
                                fontSize: "80px",
                                color: "#363636"

                            }}
                        />
                    }
                </Avatar>
                <Box
                    id="Line_Separator"
                    sx={{ borderBottom: 1, borderColor: "#e3e3e3", width: "100%", mb: "16px", mt: "16px" }}
                ></Box>
                <Typography variant="bodyVeryLargeBlack" sx={{ fontSize: "26px", pl:"24px", }}

                >{companyName}
                </Typography>

                <Box
                    id="Line_Separator"
                    sx={{ borderBottom: 1, borderColor: "#e3e3e3", width: "100%", mb: "16px", mt: "16px" }}
                ></Box>
                <Typography variant="subtitle" sx={{ alignSelf: "flex-start", mb: "16px", pl:"24px", pr:"24px",  }}

                >O nas
                </Typography>
                <Typography variant="bodySmallRegural" sx={{ alignSelf: "flex-start", fontSize: "12px", mb: "16px", pl:"24px", pr:"24px", overflow: "auto" }}

                >{companyDescription}
                </Typography>

                
                <Button
                    onClick={companyInfoOnClickButtonAction}
                    variant="outlined"
                    sx={{
                        justifySelf: "flex-end",

                        ...Theme.outlinedCancelGrayButton,
                        backgroundColor: "#F2F3F5",
                        //[Theme.breakpoints.down("laptop")]: {
                        fontSize: 12,
                        width: "199px",
                        height: "38px",
                        borderRadius: "13px",
                        border: 0,
                        mt: "auto",
                        mb:"24px"
                        //},

                    }}
                    endIcon={
                        <Avatar sx={{ bgcolor: "#f29a26", width: 20, height: 20, ml: "24px" }}>
                        <KeyboardArrowRightIcon
                            sx={{
                                fontSize: 22,
                                color: "#fff",
                            }}
                        />
                    </Avatar>
                    }
                >
                    Kontakt
                </Button>

                

                

            </Box>
            
        </ThemeProvider>

    );
};


